/*
custom apis:
core,
app.isAppInstalled,
app.launchApp,
data.setShareInfo,
data.updateLoginInfo,
device.getNetworkInfo,
offline.isCached,
tenpay.pay,
ui.closeWebViews,
ui.openUrl,
ui.popBack,
ui.refreshTitle,
ui.setOnShareHandler,
ui.setTitleButtons,
ui.shareMessage,
ui.showDialog,
ui.showShareMenu
*/
/**
 * @namespace core
 * @desc mqqapi内核的方法和属性
 */


(function(name, definition, undefined) {
  const exp = definition((window[name] = window[name] || {}));
  if (typeof define === 'function' && (define.amd || define.cmd)) {
    define(exp);
  } else if (typeof module === 'object') {
    module.exports = exp;
  }
})('mqq', (exports, undefined) => {
  if (typeof window === 'undefined') {
    return;
  }
  let ua = navigator.userAgent;
  const firebug = window.MQQfirebug; // 调试插件引用
  let Report;
  // 借用方法的常量
  const SLICE = Array.prototype.slice;
  const TOSTRING = Object.prototype.toString;
  // 各种判断用的正则
  //
  // IOS: Mozilla/5.0 (iPhone; CPU iPhone OS 8_0 like Mac OS X) AppleWebKit/600.1.3 (KHTML, like Gecko) Version/8.0 Mobile/12A4345d Safari/600.1.4
  //      Mozilla/5.0 (iPad; CPU OS 7_0 like Mac OS X) AppleWebKit/537.51.1 (KHTML, like Gecko) Version/7.0 Mobile/11A465 Safari/9537.53

  // ANDROID: Mozilla/5.0 (Linux; Android 4.4.4; en-us; Nexus 5 Build/JOP40D) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/42.0.2307.2 Mobile Safari/537.36

  // WINDOWS PHONE: Mozilla/5.0 (compatible; MSIE 10.0; Windows Phone 8.0; Trident/6.0; IEMobile/10.0; ARM; Touch; NOKIA; Lumia 520)

  const REGEXP_IOS = /\b(iPad|iPhone|iPod)\b.*? OS ([\d_]+)/;
  // fix by jdochen 2015/09/15
  // 个别低端机型UA：Android/2.3.5
  const REGEXP_ANDROID = /\bAndroid([^;]+)/; // 小米的奇葩系统没有android内核的这个数字版本号啊
  // Mozilla/5.0 (iPhone; CPU iPhone OS 7_1_2 like Mac OS X) AppleWebKit/537.51.2 (KHTML, like Gecko) Mobile/11D257 QQ/5.3.2.424 NetType/WIFI Mem/46
  const REGEXP_IPHONE_QQ = /\bQQ\/([\d\.]+)/;
  // Mozilla/5.0 (iPad; CPU OS 8_0 like Mac OS X) AppleWebKit/600.1.4 (KHTML, like Gecko) Mobile/12A365 IPadQQ/5.3.0.0 QQ/5.6
  const REGEXP_IPAD_QQ = /\bIPadQQ\/([\d\.]+).*?\bQQ\/([\d\.]+)/;
  // Mozilla/5.0 (Linux; Android 5.0.1; Nexus 4 Build/LRX22C) AppleWebKit/537.36 (KHTML, like Gecko) Version/4.0 Chrome/37.0.0.0 Mobile Safari/537.36 V1_AND_SQ_4.7.0_216_HDBM_T QQ/4.7.0.2385 NetType/WIFI
  const REGEXP_ANDROID_QQ = /\bV1_AND_SQI?_([\d\.]+)(.*? QQ\/([\d\.]+))?/; // 国际版的 QQ 的 ua 是 sqi
  const REGEXP_X5 = /\bTBS\/([\d]+)/;
  const REGEXP_WK = /\bCore\/WKWebView/;
  const REGEXP_DEBUG_WK = /\Debug\/WKWebView/;
  const REGEXP_JSBRIDGE = /^jsbridge\:\/\//;
  const REGEXP_FUDAO = /EducationApp/;
  const REGEXP_FUDAO_VERSION = /\bVersionCode\/(\d+)/;
  // TODO winphone qq

  const REGEXP_TRIBE = /\bTribe\/([\d\.]+)/; // 部落APP的 ua
  // 内部使用的变量
  const aCallbacks = exports.__aCallbacks || {}; // 调用回调
  const aReports = exports.__aReports || {}; // API 调用的名字跟回调序号的映射
  const aSupports = exports.__aSupports || {}; // 保存 API 的版本支持信息
  const aFunctions = exports.__aFunctions || {}; // 保存 API 的名字和生成的方法映射
  let UUIDSeed = 1;
  const CODE_API_CALL = -100000; // 定义为 API 调用, 跟 API 的回调区分
  const CODE_API_CALLBACK = -200000; // 定义为 API 调用的返回, 但是不知道确切返回码
  // 4.7启用了新协议, 但是部分接口不支持, 这里做个黑名单, 目前都是 android 的接口
  const NEW_PROTOCOL_BACK_LIST = {
    qbizApi: '5.0', // 5.0 会支持新协议
    pay: '999999', // pay相关的暂时没有修改计划
    SetPwdJsInterface: '999999', // 设置密码?
    GCApi: '999999', // 游戏中心
    q_download: '999999', // 下载器
    qqZoneAppList: '999999', //
    qzone_app: '999999', //
    qzone_http: '999999', //
    qzone_imageCache: '999999', //
    RoamMapJsPlugin: '999999', //
  };
  // 有些接口不能做上报
  const NOT_REPORT_METHOD = ['pbReport', 'popBack', 'close', 'qqVersion'];

  // 如果已经注入则开启调试模式
  if (firebug) {
    exports.debuging = true;
    ua = firebug.ua || ua;
  } else {
    exports.debuging = false;
  }

  /*
     * 扩展 obj 对象
     * @param  {[type]} obj [description]
     * @param  {[type]} ext [description]
     * @return {[type]}     [description]
     */
  function extend(obj, ext, overwrite) {
    let i;

    for (i in ext) {
      if ((ext.hasOwnProperty(i) && !(i in obj)) || overwrite) {
        obj[i] = ext[i];
      }
    }

    return obj;
  }

  // 生成一些列的类型判断方法
  extend(
    exports,
    (function() {
      const exp = {};
      const types = 'Object,Function,String,Number,Boolean,Date,Undefined,Null';

      types.split(',').forEach((t, i) => {
        exp[`is${t}`] = function(obj) {
          return TOSTRING.call(obj) === `[object ${t}]`;
        };
      });

      return exp;
    })()
  );

  /**
   * @attribute core.iOS
   * @desc 如果在 iOS 中，值为 true，否则为 false
   * @support iOS 4.2
   * @support android 4.2
   */
  exports.iOS = REGEXP_IOS.test(ua);
  /**
   * @attribute core.android
   * @desc 如果在 android 中，值为 true，否则为 false
   * @support iOS 4.2
   * @support android 4.2
   */
  exports.android = REGEXP_ANDROID.test(ua);

  if (exports.iOS && exports.android) {
    /*
         * 同时是 iOS 和 android 是不可能的, 但是有些国产神机很恶心,
         * 明明是 android, ua 上还加上个 iPhone 5s...
         * 这里要 fix 掉
         */
    exports.iOS = false;
  }

  /**
   * @attribute core.version
   * @desc mqqapi自身的版本号
   * @support iOS 4.2
   * @support android 4.2
   */
  exports.version = '20180928001';

  /**
   * @attribute core.QQVersion
   * @desc 如果在 手机 QQ中，值为手机QQ的版本号，如：4.6.2，否则为 0
   * @support iOS 4.2
   * @support android 4.2
   */
  exports.QQVersion = '0';

  exports.clientVersion = '0';

  exports.ERROR_NO_SUCH_METHOD = 'no such method';
  exports.ERROR_PERMISSION_DENIED = 'permission denied';

  /*
     * 当a<b返回-1, 当a==b返回0, 当a>b返回1,
     * 约定当a或b非法则返回-1
     */
  function compareVersion(a, b) {
    let i;
    let l;
    let r;
    let len;

    a = String(a).split('.');
    b = String(b).split('.');

    // try {
    for (i = 0, len = Math.max(a.length, b.length); i < len; i++) {
      l = (isFinite(a[i]) && Number(a[i])) || 0;
      r = (isFinite(b[i]) && Number(b[i])) || 0;
      if (l < r) {
        return -1;
      }
      if (l > r) {
        return 1;
      }
    }

    // } catch (e) {
    //     console.error(e);
    //     return -1;
    // }

    return 0;
  }

  /**
   * @function core.compare
   * @desc 比较版本号，返回比较结果（-1，0，1）。如果当前 QQVersion 小于给定版本，返回 -1，等于返回 0，大于返回 1
   * @param {String} version
   *
   * @example
   * mqq.QQVersion = "4.7";
   * mqq.compare("10.0");// 返回-1
   * mqq.compare("4.5.1");// 返回1
   *
   * @support iOS 4.2
   * @support android 4.2
   */
  exports.compare = function(ver) {
    return compareVersion(exports.clientVersion, ver);
  };

  /*
     * 判断各种平台，手Q，iPadQQ，部落App等
     */
  exports.platform = (function() {
    let p = 'browser';
    let m;
    let ver;

    if (exports.android) {
      // 判断手机QQ
      if ((m = ua.match(REGEXP_ANDROID_QQ)) && m.length) {
        exports.QQVersion = exports.clientVersion =
          (compareVersion(m[1], m[3]) >= 0 ? m[1] : m[3]) || '0';
        p = 'AndroidQQ';
      } else if ((m = ua.match(REGEXP_TRIBE)) && m.length) {
        // 判断部落App
        exports.clientVersion = m[1] || '0';
        p = 'AndroidTribe';
      }

      // 兼容 android 旧接口
      window.JsBridge = window.JsBridge || {};
      window.JsBridge.callMethod = invokeClientMethod;
      window.JsBridge.callback = execGlobalCallback;
      window.JsBridge.compareVersion = exports.compare;
    }

    if (exports.iOS) {
      // 用于接收客户端返回值
      exports.__RETURN_VALUE = undefined;

      if ((m = ua.match(REGEXP_IPAD_QQ)) && m.length) {
        exports.clientVersion = m[1] || '0';
        exports.QQVersion = m[2] || exports.clientVersion; // iPadQQ 可能会模拟 QQ 的版本
        p = 'iPadQQ';
      } else if ((m = ua.match(REGEXP_IPHONE_QQ)) && m.length) {
        exports.QQVersion = exports.clientVersion = m[1] || '0';
        p = 'iPhoneQQ';
      } else if ((m = ua.match(REGEXP_TRIBE)) && m.length) {
        // 判断部落App
        exports.clientVersion = m[1] || '0';
        p = 'iOSTribe';
      } else {
        // ios qq 5.9.5有bug，安装完qq后第一次打开webview，ua的设置不正确，没有qq信息在里面，因此这里尝试去调用一下同步接口，判断是否是qq。qq 6.0已经修复该问题
        // 2015/11/05 by az
        ver = invokeClientMethod('device', 'qqVersion');
        if (ver) {
          exports.QQVersion = exports.clientVersion = ver;
          p = 'iPhoneQQ';
        }
      }

      // 兼容 iOS 旧接口
      window.iOSQQApi = exports;
    }

    return p;
  })();

  UUIDSeed = (function() {
    let count = 1; // 从1开始, 因为QQ浏览器的注入广告占用了0, 避免冲突
    let i;

    for (i in aCallbacks) {
      // 有些页面会引用多份 qqapi.js，(⊙﹏⊙)b，这里对回调序号做重新矫正
      if (aCallbacks.hasOwnProperty(i)) {
        i = Number(i);

        // 事件的key值是字符串
        if (!isNaN(i)) {
          count = Math.max(count, i);
        }
      }
    }

    return ++count;
  })();

  Report = (function() {
    let reportCache = [];
    const sendFrequency = 500;
    let timer = 0;
    let lastTimerTime = 0;
    const APP_ID = 1000218;
    const TYPE_ID = 1000280;
    // 抽样比例
    const sample = 100;
    const mainVersion = String(exports.QQVersion)
      .split('.')
      .slice(0, 3)
      .join('.');
    const releaseVersion = `${exports.platform}_MQQ_${mainVersion}`;
    const qua = `${exports.platform + exports.QQVersion}/${exports.version}`;

    function sendReport() {
      const arr = reportCache;
      let params = {};
      let img;

      reportCache = [];
      timer = 0;

      if (!arr.length) {
        // 这次没有要上报的, 就关掉定时器
        return;
      }

      params.appid = APP_ID; // 手机QQ JS API
      params.typeid = TYPE_ID; // UDP 接口需要
      params.releaseversion = releaseVersion;

      // params.build = location.hostname + location.pathname;
      params.sdkversion = exports.version;
      params.qua = qua;
      params.frequency = sample;

      params.t = Date.now();

      params.key = ['commandid', 'resultcode', 'tmcost'].join(',');

      arr.forEach((a, i) => {
        params[`${i + 1}_1`] = a[0];
        params[`${i + 1}_2`] = a[1];
        params[`${i + 1}_3`] = a[2];
      });

      params = new String(toQuery(params));

      // api 的上报量太大了, 后台撑不住
      if (exports.compare('4.6') >= 0) {
        // 优先用客户端接口上报
        setTimeout(() => {
          if (mqq.iOS) {
            mqq.invokeClient('data', 'pbReport', {
              type: String(10004),
              data: params,
            });
          } else {
            mqq.invokeClient('publicAccount', 'pbReport', String(10004), params);
          }
        }, 0);
      } else {
        img = new Image();
        img.onload = function() {
          img = null;
        };

        img.src = `http://wspeed.qq.com/w.cgi?${params}`;
      }

      timer = setTimeout(sendReport, sendFrequency);
    }

    function send(api, retCode, costTime) {
      let mod;

      // API调用进行抽样上报, 返回则不抽样
      if (retCode === CODE_API_CALL) {
        retCode = 0; // API 调用的状态码用回 0
        mod = Math.round(Math.random() * sample) % sample;
        if (mod !== 1) {
          return;
        }
      }

      reportCache.push([api, retCode || 0, costTime || 0]);

      // if(Date.now() - lastTimerTime < sendFrequency){

      //     // 连续的 sendFrequency 时间内的上报都合并掉
      //     clearTimeout(timer);
      //     timer = 0;
      // }
      if (!timer) {
        lastTimerTime = Date.now();
        timer = setTimeout(sendReport, sendFrequency);
      }
    }

    return {
      send,
    };
  })();
  // 手Q的使用wkwebview的版本
  exports.__isWKWebView = exports.iOS && exports.compare('7.2.0') >= 0 && REGEXP_WK.test(ua);
  (function() {
    const matches = ua.match(REGEXP_FUDAO_VERSION);
    let fudaoVersionCode = 0;
    if (matches && matches.length > 0) {
      fudaoVersionCode = parseInt(matches[1]);
    }
    exports.fudaoVersionCode = fudaoVersionCode;
  })();

  // fudao app ios 回调方式从同步改异步 20181011
  exports.__isFudaoAPPAsync =
    exports.iOS && REGEXP_FUDAO.test(ua) && exports.fudaoVersionCode >= 42;

  function log(params) {
    const firebug = window.MQQfirebug;

    if (exports.debuging && firebug && firebug.log && params.method !== 'pbReport') {
      try {
        firebug.log(params);
      } catch (e) {}
    }
  }

  /*
     * 上报 API 调用和把 API 的回调跟 API 名字关联起来, 用于上报返回码和返回时间
     */
  function reportAPI(schema, ns, method, argus, sn) {
    if (!schema || !ns || !method) {
      // 非正常的 API 调用就不上报了
      return;
    }

    const uri = `${schema}://${ns}/${method}`;
    let a;
    let i;
    let l;
    let m;

    argus = argus || [];

    if (!sn || !(aCallbacks[sn] || window[sn])) {
      // 尝试从参数中找到回调参数名作为 sn
      sn = null;
      for (i = 0, l = argus.length; i < l; i++) {
        a = argus[i];
        if (exports.isObject(a)) {
          a = a.callbackName || a.callback;
        }

        if (a && (aCallbacks[a] || window[a])) {
          sn = a;
          break;
        }
      }
    }

    if (sn) {
      // 记录 sn 和 uri 的对应关系
      // 新增na, method，用于debug模式输出
      aReports[sn] = {
        from: 'reportAPI',
        ns,
        method,
        uri,
        startTime: Date.now(),
      };
      m = String(sn).match(/__MQQ_CALLBACK_(\d+)/);
      if (m) {
        //  兼容直接使用 createCallbackName 生成回调的情况
        aReports[m[1]] = aReports[sn];
      }
    }

    // Console.debug('sn: ' + sn, aReports);
    // 发上报请求
    Report.send(uri, CODE_API_CALL);
  }

  /*
     * 创建名字空间
     * @param  {String} name
     */
  function createNamespace(name) {
    const arr = name.split('.');
    let space = window;

    arr.forEach(a => {
      !space[a] && (space[a] = {});
      space = space[a];
    });
    return space;
  }

  /**
   * @function core.callback
   * @desc 用于生成回调名字，跟着 invoke 的参数传给客户端，客户端执行回调时，根据该回调名字找到相应的回调处理函数并执行
   * @param {Function} handler 接口的回调处理函数
   * @param {Boolean} [deleteOnExec] 若为 true 则执行完该回调之后删除之，用于防止同一个回调被多次执行（某些情况下有用）
   * @param {Boolean} [execOnNewThread] 若为 true 则在另一个线程执行回调，iOS 中，以下两种场景须指定该参数为 true
   * @default for execOnNewThread true
   *
   * @important 如果在 UI 相关接口的回调中调用 alert 等 UI 接口，会导致 WebView 假死，只能关进程处理
   * @important 如果在接口 A 的回调中继续调用接口 B，接口 B 的调用可能会无效亦或者返回结果不正确
   *
   * @example
   * var callbackName = mqq.callback(function(type, index){
   *     console.log("type: " + type + ", index: " + index);
   * });
   * //弹出 ActionSheet
   * mqq.invoke("ui", "showActionSheet", {
   *     "title" : "title",
   *     "items" : ["item1", "item2"],
   *     "cancel" : "cancel",
   *     "close" : "close",
   *     "onclick": callbackName
   * }
   *
   * @support iOS 4.2
   * @support android 4.2
   */
  function createCallbackName(callback, deleteOnExec, execOnNewThread) {
    let sn;
    let name;

    callback = exports.isFunction(callback) ? callback : window[callback];
    if (!callback) {
      return;
    }

    // // 默认执行一遍后就删掉
    // if (exports.isUndefined(deleteOnExec)) {
    //     deleteOnExec = true;
    // }

    sn = storeCallback(callback);

    name = `__MQQ_CALLBACK_${sn}`;

    // alert(name)

    window[name] = function() {
      const argus = SLICE.call(arguments);

      fireCallback(sn, argus, deleteOnExec, execOnNewThread);
    };

    return name;
  }

  function storeCallback(callback) {
    const sn = `${UUIDSeed++}`;

    if (callback) {
      /* window[sn] = */
      aCallbacks[sn] = callback;
    }

    return sn;
  }

  /*
     * 从 obj 中找出错误码
     * @param  {Object} obj
     */
  function getResultCode(obj) {
    let retCode;
    let j;
    let n;
    const keys = ['retCode', 'retcode', 'resultCode', 'ret', 'code', 'r'];

    for (j = 0, n = keys.length; j < n; j++) {
      if (keys[j] in obj) {
        retCode = obj[keys[j]];
        break;
      }
    }

    return retCode;
  }

  /*
     * 所有回调的最终被执行的入口函数
     */
  function fireCallback(sn, argus, deleteOnExec, execOnNewThread) {
    const callback = exports.isFunction(sn) ? sn : aCallbacks[sn] || window[sn];
    const endTime = Date.now();
    let result;
    let retCode;
    let obj;

    argus = argus || [];
    result = argus[0];

    // 默认都在新线程执行
    if (exports.isUndefined(execOnNewThread)) {
      execOnNewThread = true;
    }

    // 统一回调格式 { code: 0, msg: "", data: {} }
    if (exports.isObject(result)) {
      if (!('data' in result)) {
        result.data = extend({}, result);
      }

      if (!('code' in result)) {
        result.code = getResultCode(result) || 0;
      }

      result.msg = result.msg || '';
    }

    if (exports.isFunction(callback)) {
      if (execOnNewThread) {
        setTimeout(() => {
          // alert(callback)
          callback.apply(null, argus);
        }, 0);
      } else {
        callback.apply(null, argus);
      }
    } else if (sn) {
      console.log(
        `mqqapi: not found such callback: ${sn} or the callback: ${sn} had some errors! API: ${
          sn.name
        }`
      );
    }

    if (deleteOnExec) {
      delete aCallbacks[sn];
      delete window[`__MQQ_CALLBACK_${sn}`];
    }

    // 上报 API 调用返回
    // alert(sn)
    if (aReports[sn]) {
      obj = aReports[sn];
      delete aReports[sn];

      // 输出结果, 上报数据不输出
      log({
        from: 'fireCallback',
        ns: obj.ns,
        method: obj.method,
        ret: JSON.stringify(argus),
        url: obj.uri,
      });

      if (Number(sn)) {
        delete aReports[`__MQQ_CALLBACK_${sn}`];
      }

      if (result) {
        // 只取第一个参数来判断

        if (result.code !== undefined) {
          retCode = result.code;
        } else if (/^-?\d+$/.test(String(result))) {
          // 第一个参数是个整数, 认为是返回码
          retCode = result;
        }
      }

      // 发上报请求
      Report.send(`${obj.uri}#callback`, retCode, endTime - obj.startTime);
    }
  }

  /*
     * android / iOS 5.0 开始, client回调 js, 都通过这个入口函数处理
     */

  function execGlobalCallback(sn) {
    // alert(JSON.stringify(arguments))

    const argus = SLICE.call(arguments, 1);

    if (exports.android && argus && argus.length) {
      // 对 android 的回调结果进行兼容
      // android 的旧接口返回会包装个 {r:0,result:123}, 要提取出来
      argus.forEach((data, i) => {
        if (exports.isObject(data) && 'r' in data && 'result' in data) {
          argus[i] = data.result;
        }
      });
    }

    if (exports.__isWKWebView) {
      // WK接口兼容
      argus.forEach((data, i) => {
        if (exports.isObject(data) && data.syncToAsync && 'result' in data) {
          argus[i] = data.result;
        }
      });
    }
    if (exports.__isFudaoAPPAsync) {
      // fudao 同步改异步接口兼容
      argus.forEach((data, i) => {
        if (exports.isObject(data) && 'result' in data) {
          argus[i] = data.result;
        }
      });
    }
    fireCallback(sn, argus);
  }

  /*
     * 空的api实现, 用于兼容在浏览器调试, 让mqq的调用不报错
     */
  function emptyAPI() {
    // var argus = SLICE.call(arguments);
    // var callback = argus.length && argus[argus.length-1];
    // return (typeof callback === 'function') ? callback(null) : null;
  }

  /**
   * @function core.build
   * @desc 创建 api 方法, 把指定 api 包装为固定的调用形式
   * @param {String} name 需创建的命名空间，如：'mqq.ui.openUrl'
   * @param {Object} data 接口配置信息（包含接口在iOS/android/browser端的执行以及各平台手Q支持的版本）
   *
   * @example
   * mqq.build("ui.openUrl", {
   *     android: function(){},
   *     iOS: fucntion(){},
   *
   *     AndroidQQ: function(){},
   *     iPhoneQQ: fucntion(){},
   *     iPadQQ: function(){},
   *     Buluo: function(){},
   *     browser: function(){}, // 某些 api 可能有浏览器兼容的方式
   *     support: {
   *         AndroidQQ: '4.5',
   *         iPhoneQQ: '4.5',
   *         iPadQQ: '4.5',
   *         Buluo: '4.5'
   *     }
   * })
   *
   * @support iOS 4.2
   * @support android 4.2
   */
  function buildAPI(name, data) {
    let func = null;
    let str;
    const mayRecursive = false;
    let plat = exports.platform;
    const arr = name.split('.');
    const index = name.lastIndexOf('.');
    const nsName = arr[arr.length - 2];
    const methodName = arr[arr.length - 1];
    const ns = createNamespace(name.substring(0, index));

    // 该处增加debug状态判断，允许某些调试行为刻意重写`mqq`方法
    if (ns[methodName] && !exports.debuging) {
      // 多次挂载mqq会导致同一方法多次创建而导致报错终止
      return;
    }

    if (!(func = data[exports.platform]) && plat !== 'browser') {
      // 没有指定特殊平台，且不是浏览器的环境，则尝试用通用的 iOS 和android 去找
      if ((func = exports.iOS && data.iOS)) {
        plat = 'iOS';
      } else if ((func = exports.android && data.android)) {
        plat = 'android';
      }
    }

    if (func && data.supportInvoke) {
      // 缓存起来，用于兼容标准的方式调用
      aFunctions[`${nsName}.${methodName}`] = func;
    }

    // if (func && !data.supportSync) {

    //     var func2 = function() {
    //         var argus = SLICE.call(arguments),
    //             self = this;

    //         setTimeout(function() {
    //             func.apply(self, argus);
    //         }, 0);
    //     };
    // }

    ns[methodName] = func || emptyAPI;

    // 用于 supportVersion 判断
    if (data.support && data.support[plat]) {
      aSupports[`${nsName}.${methodName}`] = data.support[plat];
    }
  }

  /**
   * @function core.support
   * @desc 检查当前手机QQ环境是否支持该接口，返回 true 则表示支持该接口；false 则不支持。
   * @param {String} apiName 接口名字
   * @example
   * mqq.support("mqq.device.getClientInfo"); // return true | false
   *
   * @support iOS 4.2
   * @support android 4.2
   */
  function supportVersion(name) {
    let support;
    let vers;
    const arr = name.split('.');
    const shortName = `${arr[arr.length - 2]}.${arr[arr.length - 1]}`;

    support = aSupports[shortName] || aSupports[name.replace('qw.', 'mqq.').replace('qa.', 'mqq.')];

    if (exports.isObject(support)) {
      // 如果support是个obj，则是旧的情况，要做兼容
      support = support[exports.iOS ? 'iOS' : exports.android ? 'android' : 'browser'];
    }

    if (!support) {
      return false;
    }

    // 增加版本区间检查 20140924
    vers = support.split('-');

    if (vers.length === 1) {
      return exports.compare(vers[0]) > -1;
    }
    return exports.compare(vers[0]) > -1 && exports.compare(vers[1]) < 1;
  }

  /*
     * 使用 iframe 发起伪协议请求给客户端
     */
  function openURL(url, ns, method, sn) {
    log({
      from: 'openURL',
      ns: ns || '',
      method: method || '',
      url,
    });

    function failCallback() {
      /*
             正常情况下是不会回调到这里的, 只有客户端没有捕获这个 url 请求,
             浏览器才会发起 iframe 的加载, 但这个 url 实际上是不存在的,
             会触发 404 页面的 onload 事件
             */
      execGlobalCallback(sn, {
        r: -201,
        result: 'error',
      });
    }

    let returnValue;

    if (exports.__isWKWebView && REGEXP_JSBRIDGE.test(url)) {
      !REGEXP_DEBUG_WK.test(ua) && window.webkit.messageHandlers.jsapi.postMessage({ src: url });
    } else {
      const nodeType =
        exports.android && exports.compare('6.2.0') >= 0 && REGEXP_X5.test(ua)
          ? 'script'
          : 'iframe';
      const jsbridgeNode = document.createElement('iframe');
      let removeTimeStamp;
      jsbridgeNode.style.cssText = 'display:none;width:0px;height:0px;';
      jsbridgeNode.onerror = function(e) {
        // 在 android 4.0-4.3 中,script节点的src赋值成jsbridge://ui/showDialog的形式会报错
        e.stopPropagation();
      };
      if (exports.iOS) {
        /*
                ios 必须先赋值, 然后 append, 否者连续的 api调用会间隔着失败
                也就是 api1(); api2(); api3(); api4(); 的连续调用,
                只有 api1 和 api3 会真正调用到客户端
                */
        jsbridgeNode.onload = failCallback;
        jsbridgeNode.src = url;
      }

      // 201707有时候根元素没有appendChild
      const root = document.body || document.documentElement;
      root.appendChild && root.appendChild(jsbridgeNode);

      /*
            android 这里必须先添加到页面, 然后再绑定 onload 和设置 src
            1. 先设置 src 再 append 到页面, 会导致在接口回调(callback)中嵌套调用 api会失败,
            iframe会直接当成普通url来解析
            2. 先设置onload 在 append , 会导致 iframe 先触发一次 about:blank 的 onload 事件

            */
      if (exports.android) {
        // android 必须先append 然后赋值
        jsbridgeNode.onload = failCallback;
        jsbridgeNode.src = url;
      }
      if (url.indexOf('mqqapi://') > -1 && exports.android) {
        removeTimeStamp = 0;
      } else {
        removeTimeStamp = 500;
      }
      // android 捕获了iframe的url之后, 也是中断 js 进程的, 所以这里可以用个 setTimeout 0 来删除 iframe
      setTimeout(() => {
        jsbridgeNode &&
          jsbridgeNode.parentNode &&
          jsbridgeNode.parentNode.removeChild(jsbridgeNode);
      }, removeTimeStamp);
    }

    if (!(exports.__isWKWebView || exports.__isFudaoAPPAsync)) {
      // iOS 可以同步获取返回值, 因为 iframe 的url 被客户端捕获之后, 会挂起 js 进程
      returnValue = exports.__RETURN_VALUE;
      exports.__RETURN_VALUE = undefined;
    }

    return returnValue;
  }

  function isAndroidQQAndRequireCompatible(ns, method) {
    if (exports.platform === 'AndroidQQ') {
      if (exports.compare('4.7.2') < 0) {
        return true;
      }

      if (NEW_PROTOCOL_BACK_LIST[ns] && exports.compare(NEW_PROTOCOL_BACK_LIST[ns]) < 0) {
        return true;
      }
    }

    return false;
  }

  /**
   * @function core.invokeURL
   * @desc mqq 核心方法，用于调用客户端接口。
   * @param {String} url 最终传给终端的url, 不支持回调.
   * @example
   * // 调用普通接口
   * // ios, android
   * mqq.invokeURL("weixin://ns/method");
   *
   * @important 此方法主要在使用手Q外的其它协议时使用
   */
  function invokeURL(url) {
    openURL(url);
  }

  /**
   * @function core.invoke
   * @desc mqq 核心方法，用于调用客户端接口。invoke 封装了两个系统（android、ios）的不同，同时对不同版本进行了兼容。
   * @param {String} namespace 命名空间，每个客户端接口都属于一个命名空间，若不清楚，请咨询对应的客户端开发
   * @param {String} method 接口名字
   * @param {Object} [params] API 调用的参数
   * @param {Function} [callback] API 调用的回调
   * @important 因历史版本的客户实现问题，同一个接口在 android 和 iOS 命名空间和方法名都不一致，同时接口实现的也可能有些许差异，因此尽量使用下面封装好的方法，如：mqq.ui.openUrl。直接调用 invoke 的情况只建议在 android 和 iOS 的实现命名空间和方法以及参数格式都完全一致时使用。
   * @example
   * // 调用普通接口
   * // ios, android
   * mqq.invoke("ns", "method");
   *
   * @example
   * // 调用需要传参数的接口
   * mqq.invoke("ns", "method", {foo: 'bar'});
   *
   * @example
   * // 调用需要传参数且有回调结果的接口
   * mqq.invoke("ns", "method", {foo: 'bar'}, function(data){
   *     console.log(data);
   * });
   *
   *
   * @support iOS 4.2
   * @support android 4.2
   * @support for params iOS 4.5
   * @support for params android 4.7
   */
  function invokeClientMethod(ns, method, params, callback) {
    // 限制iframe里面调用
    if (!ns || !method || window !== window.top) {
      return null;
    }

    let url;
    let sn;
    let argus;
    let result;
    let lastParam;
    const constCBStr = '__MQQ_CALLBACK_'; // sn 是回调函数的序列号

    argus = SLICE.call(arguments, 2);
    callback = argus.length && argus[argus.length - 1];

    if (exports.isFunction(callback)) {
      // args最后一个参数是function, 说明存着callback
      argus.pop();
    } else if (exports.isUndefined(callback)) {
      // callback 是undefined的情况, 可能是 api 定义了callback, 但是用户没传 callback, 这时候要把这个 undefined的参数删掉
      argus.pop();
    } else {
      callback = null;
    }
    params = argus[0]; // 一般的接口调用只会有一个参数，这里也只对第一个参数做些特殊处理
    // TODO:以下注释代码需要测试
    // lastParam = argus[argus.length - 1];
    // //调用mqq.callback的方式有如下几种
    // //1.第三个参数直接传mqq.callback(callback)的返回值，为字符串
    // //2.第三个参数传一个对象，对象的callback字段传mqq.callback(callback)的返回值
    // //3.在最后一个参数(不一定是第四个)，直接传入mqq.callback(callback)的返回值
    // if(typeof(params) == 'string' && params.indexOf(constCBStr) == 0){
    //     sn = parseInt(argus[0].replace(constCBStr,''));
    // } else if(exports.isObject(params) && params['callback'] && params['callback'].indexOf(constCBStr) == 0){
    //     sn = parseInt(params['callback'].replace(constCBStr,''));
    // } else if(typeof(lastParam) == 'string' && lastParam.indexOf(constCBStr) == 0){
    //     sn = parseInt(lastParam.replace(constCBStr,''));
    // } else{
    //     //原始逻辑
    //     // 统一生成回调序列号, callback 为空也会返回 sn
    //     sn = storeCallback(callback);
    // }
    sn = storeCallback(callback);

    if (NOT_REPORT_METHOD.indexOf(method) === -1) {
      // 上报 API 调用, openURL 会阻塞 js 线程, 因此要先打点和上报
      reportAPI('jsbridge', ns, method, argus, sn);
    }

    // 如果最后一个参数传了 function, 且 params 里面没有 'callback' 属性的, 把function赋值给params
    // 兼容之后, 任何参数调用都可以直接 mqq.invoke('ns', 'method', params, callback) 了
    // az @ 2015/4/17

    // 兼容mqq.invoke('ns', 'method', params, callback) 以及 mqq.invoke('ns', 'method', callback)
    if (exports.__isFudaoAPPAsync && callback && !params) {
      argus[0] = {};
      params = argus[0];
    }

    if (callback && exports.isObject(params) && !params.callback) {
      window[`__MQQ_CALLBACK_AUTO_${sn}`] = callback;
      params.callback = `__MQQ_CALLBACK_AUTO_${sn}`;
    }

    if (isAndroidQQAndRequireCompatible(ns, method)) {
      // android qq 小于 4.7.2的版本需要一些兼容处理

      // 进入到这个分支的，要不版本号小于 4.7.2 ，要不则接口需要用旧协议兼容

      /*
             * Android 4.5 到 4.7.2 支持旧的 jsbridge 协议，4.7.2之后与 ios 进行了统一
             * 三星特供版（ua 里面有_NZ）, 从 4.2.1 拉的分支, 4.2.1 已经去掉了注入到全局对象的方法，但是有支持 jsbridge
             */
      if (exports.compare('4.5') > -1 || /_NZ\b/.test(ua)) {
        // AndroidQQ 且不支持新 jsbridge 协议的版本， 用旧协议拼接
        // 还有部分接口在 4.7.2 还不能使用新协议, 后续版本会修复该问题

        // jsbridge://ns/method/123/test/xxx/yyy
        url = `jsbridge://${encodeURIComponent(ns)}/${encodeURIComponent(method)}/${sn}`;

        argus.forEach(a => {
          if (exports.isObject(a)) {
            a = JSON.stringify(a);
          }

          url += `/${encodeURIComponent(String(a))}`;
        });

        openURL(url, ns, method, sn);
      } else {
        // android 4.5 以下，不支持 jsbridge，但是有注入 java 对象到 js 上下文中
        if (window[ns] && window[ns][method]) {
          result = window[ns][method].apply(window[ns], argus);
          if (callback) {
            fireCallback(sn, [result]);
          } else {
            return result;
          }
        } else if (callback) {
          fireCallback(sn, [exports.ERROR_NO_SUCH_METHOD]);
        }
      }
    } else {
      // 剩下的都用新协议

      /*
             android 4.7 以上的支持 ios的协议, 但是客户端的旧接口需要迁移, 4.7赶不上, 需要等到 4.7.2
             jsbridge://ns/method?p=test&p2=xxx&p3=yyy#123
             */
      url = `jsbridge://${encodeURIComponent(ns)}/${encodeURIComponent(method)}`;

      argus.forEach((a, i) => {
        if (exports.isObject(a)) {
          a = JSON.stringify(a);
        }

        if (i === 0) {
          url += '?p=';
        } else {
          url += `&p${i}=`;
        }

        url += encodeURIComponent(String(a));
      });

      // 01.21增加一个安卓端的参数，来避免内核侧认为在没有参数的情况下是同一资源，导致后续的同名请求失败
      if (callback && exports.android && exports.compare('7.5.5') >= 0) {
        if (url.indexOf('?') !== -1) {
          url += `&mqq_tt=${+new Date()}`;
        } else {
          url += `?mqq_tt=${+new Date()}`;
        }
      }

      // 加上回调序列号
      if (method !== 'pbReport') {
        /*
                 * pbReport 这个接口不能加回调序号, 这个接口本来就不支持回调
                 * 但是 android 的 jsbridge 即使接口没有回调结果, 也会调用一次 js 表示这次接口调用到达了客户端
                 * 同时, 由于 android 一执行 loadUrl('javascript:xxx') 就会导致软键盘收起
                 * 所以上报的时候经常会引发这个问题, 这里就直接不加回调序号了
                 */

        url += `#${sn}`;
      }

      result = openURL(url, ns, method);

      if (exports.iOS && result !== undefined && result.result !== undefined) {
        // FIXME 这里可能会导致回调两次, 但是 iOS 4.7.2以前的接口是依靠这里实现异步回调, 因此要验证下
        if (callback) {
          fireCallback(sn, [result.result]);
        } else {
          return result.result;
        }
      }
    }

    return null;
  }

  function invoke(ns, method, argus, callback) {
    const func = aFunctions[`${ns}.${method}`];

    if (exports.isFunction(func)) {
      // 调用参数要去掉ns 和 method
      return func.apply(this, SLICE.call(arguments, 2));
    }

    return invokeClientMethod.apply(this, SLICE.call(arguments));
  }
  /**
   * @function core.invokeSchema
   * @desc 调用手机QQ的原有schema接口，主要用于旧的 schema 接口兼容。
   * @param {String} schema 协议名字
   * @param {String} namespace 命名空间，每个客户端接口都属于一个命名空间，若不清楚，请咨询对应的客户端开发
   * @param {String} method 接口名字
   * @param {Object} [params] API 调用的参数
   * @param {Function} [callback] API 调用的回调
   * @example
   * mqq.invokeSchema("mqqapi", "card", "show_pslcard", { uin: "123456" }, callback);
   *
   * @support iOS 4.2
   * @support android 4.2
   */
  function invokeSchemaMethod(schema, ns, method, params, callback) {
    if (!schema || !ns || !method) {
      return null;
    }

    const argus = SLICE.call(arguments);
    let sn;
    let url;

    if (exports.isFunction(argus[argus.length - 1])) {
      callback = argus[argus.length - 1];
      argus.pop();
    } else {
      callback = null;
    }

    if (argus.length === 4) {
      params = argus[argus.length - 1];
    } else {
      params = {};
    }

    if (callback) {
      params.callback_type = 'javascript';
      sn = createCallbackName(callback);
      params.callback_name = sn;
    }

    params.src_type = params.src_type || 'web';

    if (!params.version) {
      params.version = 1;
    }

    url = `${schema}://${encodeURIComponent(ns)}/${encodeURIComponent(method)}?${toQuery(params)}`;
    openURL(url, ns, method);

    // 上报 API 调用
    reportAPI(schema, ns, method, argus, sn);
  }

  // ////////////////////////////////// util /////////////////////////////////////////////////
  function mapQuery(uri) {
    let i;
    let key;
    let value;
    let index = uri.indexOf('?');
    const pieces = uri.substring(index + 1).split('&');
    let piece;
    const params = {};

    for (i = 0; i < pieces.length; i++) {
      piece = pieces[i];
      index = piece.indexOf('=');
      if (index === -1) {
        // 只有一个 key的情况
        params[piece] = '';
      } else {
        key = piece.substring(0, index);
        value = piece.substring(index + 1);
        params[key] = decodeURIComponent(value);
      }
    }

    return params;
  }

  function toQuery(obj) {
    const result = [];
    let key;
    let value;

    for (key in obj) {
      if (obj.hasOwnProperty(key)) {
        key = String(key);
        value = String(obj[key]);
        if (key === '') {
          result.push(value);
        } else {
          result.push(`${key}=${encodeURIComponent(value)}`);
        }
      }
    }

    return result.join('&');
  }

  function removeQuery(url, keys) {
    let a = document.createElement('a');
    let obj;

    a.href = url;

    if (a.search) {
      obj = mapQuery(String(a.search).substring(1));
      keys.forEach(k => {
        delete obj[k];
      });
      a.search = `?${toQuery(obj)}`;
    }

    // if (a.hash) {
    //     obj = mapQuery(String(a.hash).substring(1));
    //     keys.forEach(function(k) {
    //         delete obj[k];
    //     });
    //     a.hash = '#' + toQuery(obj);
    // }

    url = a.href;
    a = null;

    return url;
  }

  // ////////////////////////////////// end util /////////////////////////////////////////////////

  // ////////////////////////////////// event /////////////////////////////////////////////////

  /**
   * @function core.addEventListener
   * @desc 监听客户端事件，该事件可能来自客户端业务逻辑，也可能是其他 WebView 使用 dispatchEvent 抛出的事件
   * @param {String} eventName 事件名字
   * @param {Function} handler 事件的回调处理函数
   * @param {Object} handler.data 该事件传递的数据
   * @param {Object} handler.source 事件来源
   * @param {string} handler.source.url 抛出该事件的页面地址
   * @example
   * mqq.addEventListener("hiEvent", function(data, source){
   *     console.log("someone says hi", data, source);
   * })
   *
   * @support iOS 5.0
   * @support android 5.0
   */
  function addEventListener(eventName, handler) {
    if (eventName === 'qbrowserVisibilityChange') {
      // 兼容旧的客户端事件
      document.addEventListener(eventName, handler, false);
      return true;
    }

    const evtKey = `evt-${eventName}`;

    (aCallbacks[evtKey] = aCallbacks[evtKey] || []).push(handler);
    return true;
  }

  /**
   * @function core.removeEventListener
   * @desc 移除客户端事件的监听器
   * @param {String} eventName 事件名字
   * @param {Function} [handler] 事件的回调处理函数，不指定 handler 则删除所有该事件的监听器
   *
   * @support iOS 5.0
   * @support android 5.0
   */
  function removeEventListener(eventName, handler) {
    const evtKey = `evt-${eventName}`;
    const handlers = aCallbacks[evtKey];
    let flag = false;
    let i;

    if (!handlers) {
      return false;
    }

    if (!handler) {
      delete aCallbacks[evtKey];
      return true;
    }

    for (i = handlers.length - 1; i >= 0; i--) {
      if (handler === handlers[i]) {
        handlers.splice(i, 1);
        flag = true;
      }
    }

    return flag;
  }

  // 这个方法时客户端回调页面使用的, 当客户端要触发事件给页面时, 会调用这个方法
  function execEventCallback(eventName /* , data, source */) {
    const evtKey = `evt-${eventName}`;
    const handlers = aCallbacks[evtKey];
    const argus = SLICE.call(arguments, 1);

    if (handlers) {
      handlers.forEach(handler => {
        fireCallback(handler, argus, false);
      });
    }
  }
  /**
   * @function core.dispatchEvent
   * @desc 抛出一个事件给客户端或者其他 WebView，可以用于 WebView 间通信，或者通知客户端对特殊事件做处理（客户端需要做相应开发）
   * @param {String} eventName 事件名字
   * @param {Object} data 事件传递参数
   * @param {Object} options 事件参数
   * @param {Boolean} options.echo 当前webview是否能收到这个事件，默认为true
   * @param {Boolean} options.broadcast 是否广播模式给其他webview，默认为true
   * @param {Array|String} options.domains 指定能接收到事件的域名，默认只有同域的webview能接收，支持通配符，比如"*.qq.com"匹配所有qq.com和其子域、"*"匹配所有域名。注意当前webview是否能接收到事件只通过echo来控制，这个domains限制的是非当前webview。
   * @example
   * //1. WebView 1(www.qq.com) 监听 hello 事件
   * mqq.addEventListener("hello", function(data, source){
   *    console.log("someone says hi to WebView 1", data, source)
   * });
   * //2. WebView 2(www.tencent.com) 监听 hello 事件
   * mqq.addEventListener("hello", function(data, source){
   *    console.log("someone says hi to WebView 2", data, source)
   * });
   * //3. WebView 2 抛出 hello 事件
   * //不传配置参数，默认只派发给跟当前 WebView 相同域名的页面, 也就是只有 WebView 2能接收到该事件（WebView 1 接收不到事件，因为这两个 WebView 的域名不同域）
   * mqq.dispatchEvent("hello", {name: "abc", gender: 1});
   *
   * //echo 为 false, 即使 WebView 2 的域名在 domains 里也不会收到事件通知, 该调用的结果是 WebView 1 将接收到该事件
   * mqq.dispatchEvent("hello", {name:"alloy", gender:1}, {
   *     //不把事件抛给自己
   *     echo: false,
   *     //广播事件给其他 WebView
   *     broadcast: true,
   *     //必须是这些域名的 WebView 才能收到事件
   *     domains: ["*.qq.com", "*.tencent.com"]
   * });
   *
   * //echo 和 broadcast 都为 false, 此时不会有 WebView 会接收到事件通知, 但是客户端仍会收到事件, 仍然可以对该事件做处理, 具体逻辑可以每个业务自己处理
   * mqq.dispatchEvent("hello", {name:"alloy", gender:1}, {
   *     echo: false,
   *     broadcast: false,
   *     domains: []
   * });
   *
   * @support iOS 5.0
   * @support android 5.0
   */
  function dispatchEvent(eventName, data, options) {
    const params = {
      event: eventName,
      data: data || {},
      options: options || {},
    };
    let url;

    if (exports.android && params.options.broadcast === false && exports.compare('5.2') <= 0) {
      // 对 android 的 broadcast 事件进行容错, broadcast 为 false 时,
      // 没有 Webview会接收到该事件, 但客户端依然要能接收
      // 5.2 已经修复该问题
      params.options.domains = ['localhost'];
      params.options.broadcast = true;
    }

    if (exports.platform !== 'browser') {
      // 浏览器环境不要调用这个接口
      url = `jsbridge://event/dispatchEvent?p=${encodeURIComponent(JSON.stringify(params) || '')}`;
      openURL(url, 'event', 'dispatchEvent');

      reportAPI('jsbridge', 'event', 'dispatchEvent');
    }
  }

  /**
   * @event qbrowserTitleBarClick
   * @desc 点击标题栏事件，监听后点击手机QQ标题栏就会收到通知，可以用来实现点击标题滚动到顶部的功能
   * @param {Function} callback 事件回调
   * @param {Object} callback.data 事件参数
   * @param {Object} callback.data.x 点击位置的屏幕x坐标
   * @param {Object} callback.data.y 点击位置的屏幕y坐标
   * @param {Object} callback.source 事件来源
   * @example
   * mqq.addEventListener("qbrowserTitleBarClick", function(data, source){
   *     console.log("Receive event: qbrowserTitleBarClick, data: " + JSON.stringify(data) + ", source: " + JSON.stringify(source));
   * });
   *
   * @support iOS 5.2
   * @support android 5.2
   */

  /**
   * @event qbrowserOptionsButtonClick
   * @desc Android 的物理菜单键的点击事件，点击后会收到通知
   * @param {Function} callback 事件回调
   * @param {Object} callback.data 事件参数
   * @param {Object} callback.source 事件来源
   * @example
   * mqq.addEventListener("qbrowserOptionsButtonClick", function(data, source){
   *     console.log("Receive event: qbrowserOptionsButtonClick, data: " + JSON.stringify(data) + ", source: " + JSON.stringify(source));
   * });
   *
   * @support iOS not support
   * @support android 5.2
   */

  /**
   * @event qbrowserPullDown
   * @desc 页面下拉刷新时候会抛出该事件，主要用于与setPullDown交互，具体可参考setPullDown
   * @example
   * mqq.addEventListener("qbrowserPullDown", function () {
   *     // ... Your Code ...
   * });
   * @note 该事件可配合下拉刷新做交互，具体可参考`setPullDown`
   *
   * @support iOS 5.3
   * @support android 5.3
   */

  /**
   * @event qbrowserVisibilityChange
   * @desc 当webview可见性发生改变时将会抛出该事件
   * @example
   * mqq.addEventListener("qbrowserVisibilityChange", function(e){
   *     console.log(e.hidden);
   * });
   *
   * @support iOS 4.7
   * @support android 4.7
   */

  // ////////////////////////////////// end event /////////////////////////////////////////////////

  // for debug
  exports.__aCallbacks = aCallbacks;
  exports.__aReports = aReports;
  exports.__aSupports = aSupports;
  exports.__aFunctions = aFunctions;

  // for internal use
  exports.__fireCallback = fireCallback;
  exports.__reportAPI = reportAPI;

  // 扩展 exports 对象
  extend(
    exports,
    {
      // core
      invoke,
      invokeClient: invokeClientMethod,
      invokeSchema: invokeSchemaMethod,
      invokeURL,
      build: buildAPI,
      callback: createCallbackName,
      support: supportVersion,
      execGlobalCallback,

      // event
      addEventListener,
      removeEventListener,
      dispatchEvent,
      execEventCallback,

      // util
      mapQuery,
      toQuery,
      removeQuery,
    },
    true
  );

  return exports;
});
/**
 * @function app.isAppInstalled
 * @desc 通过scheme(iOS)或packageName(Android)判断指定应用是否已经安装，注意若是iOS，参数identifier填应用的scheme，android填packageName
 *
 * @param {String} identifier
 * @param {Function} callback 回调函数
 * @param {Boolean} callback.result 返回查询结果。
 *
 * @example
 * //检测手机QQ是否安装
 * var value = "mqq"; //ios
 * //var value = "com.tencent.mobileqq"; //android
 * mqq.app.isAppInstalled(value, function(result){
 *     alert("mobileqq is install: " + result);
 * });
 * @care 泄露用户本地安装app信息
 *
 * @important iOS9新增了scheme白名单限制，如没加手Q LSQpplicationQueriesSchemes白名单(在手Q终端开发工程中添加)，该接口在iOS9上不能正常工作，详情见（https://developer.apple.com/reference/uikit/uiapplication/1622952-canopenurl?language=objcs）。 因此不推荐使用此接口! 建议不检查是否安装, 直接呼起应用替代。
 * @important 如果需要正常检测应用是否安装，必须同时满足以下两个条件：<br> 1、请找终端开发往qqvip-info.plist或qq-info.plist或qqdb-info.plist三个文件中（任选一个）的LSApplicationQueriesSchemes节点添加scheme（必须随手Q版本发布, 且白名单有数量限制，大量的scheme不建议添加）<br> 2、把scheme添加到webview白名单（白名单申请 http://ak.oa.com/whitelist/manage/index.html#/whitelist）
 * @support iOS 4.2
 * @support android 4.2
 */
mqq.build('mqq.app.isAppInstalled', {
  iOS(scheme, callback) {
    if (mqq.__isWKWebView) {
      mqq.invokeClient('app', 'isInstalled', {
        scheme,
        callback: mqq.callback(callback),
      });
    } else {
      return mqq.invokeClient(
        'app',
        'isInstalled',
        {
          scheme,
        },
        callback
      );
    }
  },
  android(identifier, callback) {
    mqq.invokeClient('QQApi', 'isAppInstalled', identifier, callback);
  },
  supportInvoke: true,
  support: {
    iOS: '4.2',
    android: '4.2',
  },
});
/**
 * @function app.launchApp
 * @desc 使用 schema(iOS) 或者 包名 (android) 启动一个 app
 *
 * @param {String} schema 应用的schema或者包名
 * @param {Object} [params] 参数字面量对象[仅iOS支持]
 *
 * @example
 * mqq.app.launchApp("mqq", {
 *      type: 2
 * }); //iOS
 * mqq.app.launchApp("com.tencent.mobileqq"); //android
 *
 * @care 泄露用户本地安装app信息
 * @support iOS 4.2
 * @support android 4.2
 */
mqq.build('mqq.app.launchApp', {
  iOS(schema, params) {
    if (!schema) {
      return;
    }
    // 兼容原有的object参数类型
    if (schema && schema.name) {
      params = schema;
      schema = schema.name;
      delete schema.name;
    }

    if (schema.indexOf('://') == -1) {
      schema += '://';
    }

    let url = schema;
    if (params) {
      url = schema + (schema.indexOf('?') > -1 ? '&' : '?') + mqq.toQuery(params);
    }
    mqq.invokeURL(url);
  },
  android(schema) {
    // 兼容原有的object参数类型
    if (schema && schema.name) {
      schema = schema.name;
    }
    mqq.invokeClient('QQApi', 'startAppWithPkgName', schema);
  },
  supportInvoke: true,
  support: {
    iOS: '4.2',
    android: '4.2',
  },
});
/**
 * @function data.setShareInfo
 * @desc 定制分享出去的url，图片，和文字等
 *
 * @param {Object} params
 * @param {String} [params.share_url] 页面可以定制分享出去的url，可去掉某些敏感参数等，如果不传，则使用页面的url，长度不能超过120字节，超过的请转短链。另外，url必须跟页面url同一个域名，否则设置不生效。
 * @param {String} params.title 分享的标题，最大45字节
 * @param {String} params.desc 分享的摘要，最大60字节
 * @param {String} [params.image_url] 图片URL，原 imageUrl 参数，可以继续使用 imageUrl。注意：图片最小需要200 * 200，否则分享到Qzone时会被Qzone过滤掉。
 * @param {String} [params.source_name] 分享的来源，默认是”QQ浏览器“
 * @param {Function} callback
 *
 * @support iOS 4.6
 * @support android 4.6
 *
 * @example
 * // 另外使用meta同样可以达到该接口的作用
 * <meta itemprop="name" content="这是分享的标题"/>
 * <meta itemprop="image" content="http://imgcache.qq.com/qqshow/ac/v4/global/logo.png" />
 * <meta name="description" itemprop="description" content="这是要分享的内容" />
 *
 * @important iOS端不支持callback回调
 */
mqq.build('mqq.data.setShareInfo', {
  iOS(params, callback) {
    if (params.share_url) {
      params.share_url = mqq.removeQuery(params.share_url, ['sid', '3g_sid']);
    }
    if (params.desc) {
      params.desc = params.desc.length > 50 ? `${params.desc.substring(0, 50)}...` : params.desc;
    }
    return mqq.invokeClient(
      'data',
      'setShareInfo',
      {
        params,
      },
      callback
    );
  },
  android(params, callback) {
    if (params.share_url) {
      params.share_url = mqq.removeQuery(params.share_url, ['sid', '3g_sid']);
    }
    if (params.desc) {
      params.desc = params.desc.length > 50 ? `${params.desc.substring(0, 50)}...` : params.desc;
    }
    mqq.invokeClient('QQApi', 'setShareInfo', params, callback);
  },
  supportInvoke: true,
  support: {
    iOS: '4.6',
    android: '4.6',
  },
});
/**
 * @function data.updateLoginInfo
 * @desc 刷新票据，包括：skey，pskey，pt4_token
 *
 * @param {Object} param 参数不能不传，否则会报js错误
 *
 * @param {String} param.key 刷新哪种票据
 * @options for param.key skey
 * @options for param.key pskey
 * @options for param.key pt4_token
 *
 * @param {String} param.callback 回调
 */
/**
 * @function device.getNetworkInfo
 * @desc 获取细化的具体网络类型
 *
 * @param {Function} callback 回调
 * @param {Object} callback.param
 * @param {Number} callback.param.type 网络类型，和原本的getNetworkType接口一样
 * @options for callback.param.type -1: Unknown 未知类型网络
 * @options for callback.param.type 0: NotReachable
 * @options for callback.param.type 1: ReachableViaWiFi
 * @options for callback.param.type 2: ReachableVia2G
 * @options for callback.param.type 3: ReachableVia3G
 * @options for callback.param.type 4. 4G
 *
 * @param {String} callback.param.radio 细化的网络类型
 * @options for callback.param.radio gprs, edge, cdma, 1xrtt, evdo0, evdoa, evdob, iden //2G
 * @options for callback.param.radio wcdma, umts, hsdpa, hsupa, hspa, ehrpd, hspap //3G
 * @options for callback.param.radio lte //4G
 * @options for callback.param.radio wifi
 * @options for callback.param.radio unknown
 *
 * @param {Number} callback.carriertype 运营商 (6.5.0 开始支持)
 * @options for callback.carriertype 0: 未知
 * @options for callback.carriertype 1: 中国移动
 * @options for callback.carriertype 2: 中国联通
 * @options for callback.carriertype 3: 中国电信
 * @options for callback.carriertype 4. 中国铁通
 *
 * @support iOS 5.2
 * @support android 5.2
 *
 * @care 存在网络信息泄露风险
 */
(function() {
  const RADIO_TYPE_MAP = {
    // ios
    // 2G
    CTRadioAccessTechnologyGPRS: 'gprs',
    CTRadioAccessTechnologyEdge: 'edge',
    // 3G
    CTRadioAccessTechnologyWCDMA: 'wcdma',
    CTRadioAccessTechnologyHSDPA: 'hsdpa',
    CTRadioAccessTechnologyCDMA1x: 'cdma',

    CTRadioAccessTechnologyCDMAEVDORev0: 'evdo0',
    CTRadioAccessTechnologyCDMAEVDORevA: 'evdoa',
    CTRadioAccessTechnologyCDMAEVDORevB: 'evdob',
    // 4G
    CTRadioAccessTechnologyeHRPD: 'ehrpd',
    CTRadioAccessTechnologyLTE: 'lte',
    // Android
    // 2G
    // 通用分组无线服务技术（General Packet Radio Service，缩写：GPRS）是GSM移动电话用户可用的一种移动数据业务。 它经常被描述成“2.5G”，也就是说这项技术位于第二代（2G）和第三代（3G）移动通讯技术之间。它通过利用GSM网络中未使用的TDMA信道，提供中速的数据传递。最初有人想通过扩展GPRS来覆盖其他标准，只是这些网络都正在转而使用GSM标准，这样GSM就成了GPRS唯一能够使用的网络。GPRS在Release 97之后被集成进GSM标准,起先它是由ETSI标准化的，但是当前已经移交3GPP负责。
    NETWORK_TYPE_GPRS: 'gprs',
    // GSM增强数据率演进（Enhanced Data rates for GSM Evolution，缩写：EDGE），是一种数字移动电话技术，作为一个2G和2.5G（GPRS）的延伸，有时被称为2.75G。这项技术工作在TDMA和GSM网络中。EDGE（通常又称为：EGPRS）是GPRS的扩展，可以工作在任何已经部署GPRS的网络上。（只要MS和BTS设备做一些必要的升级）。
    NETWORK_TYPE_EDGE: 'edge',

    // 码分多址（英语：Code Division Multiple Access，即：CDMA）或分码多重进接、码分复存，是一种多址接入的无线通信技术。CDMA最早用于军用通信，但时至今日，已广泛应用到全球不同的民用通信中。在CDMA移动通信中，将话音频号转换为数字信号，给每组数据话音分组增加一个地址，进行扰码处理，并且将它发射到空中。CDMA最大的优点就是相同的带宽下可以容纳更多的呼叫，而且它还可以随话音传送数据信息。
    NETWORK_TYPE_CDMA: 'cdma',

    NETWORK_TYPE_1xRTT: '1xrtt',

    // EV-DO是英文Evolution-Data Optimized或者Evolution-Data only的缩写。有时也写做EVDO或者EV。CDMA2000 1xEV-DO是一种可以满足移动高速数据业务的技术。一条EV-DO信道的频宽为1.25 MHz[1]。实际建网时需要使用两个不同的载波支持语音与数据业务，这虽然降低了频率利用率，不过从频谱效率上看，CDMA2000 1X+CDMA2000 1xEV-DO的传输数据能力已经大大超过WCDMA（目前WCDMA能够实现的R4版本空中接口速率为2.4Mbps/5Mhz，而CDMA2000 1xEV-DO Release 0速率为2.4Mbps，CDMA2000 1xEV-DO Revision A速率为3.1Mbps，CDMA2000 1xEV-DO Revision B速率为9.3Mbps）。而且从技术实现上面来看，语音业务和数据业务分开，既保持了高质量的语音，又获得了更高的数据传输速率。网络规划和优化上CDMA2000 1X和CDMA2000 1xEV-DO也相同，各个主要设备制造商的系统都能支持从CDMA2000 1X向CDMA2000 1xEV-DO的平滑升级，这对于电信运营商在技术和投资方面的选择都很理想，有助于CDMA2000 1xEV-DO的推广。
    NETWORK_TYPE_EVDO_0: 'evdo0',
    NETWORK_TYPE_EVDO_A: 'evdoa',
    NETWORK_TYPE_EVDO_B: 'evdob',

    // 集成数字增强网络, (Integrated Digital Enhanced Network - iDEN),是一种由摩托罗拉公司开发的数字无线通信技术。它的特点是为用户同时提供集群电话的双向对讲功能和蜂窝电话的功能。iDEN系统在无线接口使用时分多址技术。使用iDEN技术的最大运营商是美国Nextel公司。
    NETWORK_TYPE_IDEN: 'iden',
    // 3G
    // 通用移动通讯系统（Universal Mobile Telecommunications System，缩写：UMTS）是当前最广泛采用的一种第三代（3G） 移动电话技术。它的无线接口使用WCDMA技术，由 3GPP定型，代表欧洲对ITU IMT-2000 关于3G蜂窝无线系统需求的回应。UMTS有时也叫3GSM，强调结合了3G技术而且是GSM标准的后续标准。UMTS 分组交换系统是由 GPRS 系统所演进而来，故系统的架构颇为相像。
    NETWORK_TYPE_UMTS: 'umts',

    // 高速下行分组接入（High Speed Downlink Packet Access的缩写HSDPA）是一种移动通信协议，亦称为3.5G(3?G)，属于WCDMA技术的延伸。该协议在WCDMA下行链路中提供分组数据业务，在一个5MHz载波上的传输速率可达8-10 Mbit/s（如采用MIMO技术，则可达20 Mbit/s）。在具体实现中，采用了自适应调制和编码（AMC）、多输入多输出（MIMO）、混合自动重传请求（HARQ）、快速调度、快速小区选择等技术。由于开放了新的高速下行链路共享信道（High-Speed Downlink Shared Channel，HS-DSCH），加上强化了本身的传输技术，包括优化数据分组传送调度及出现错误时的传送程序、采用较短帧长（frame length）以加快分组传送调度、加入递增冗余（Incremental Redundancy）减少重新传送对接口的负担等，令HSDPA的数据下载速度最高可达14.4Mbps，理论上可以比3G技术快5倍，比GPRS技术快20倍。
    NETWORK_TYPE_HSDPA: 'hsdpa',

    // 高速上行分组接入（High Speed Uplink Packet Access 的缩写 HSUPA）是一种因 HSDPA 上传速度不足（只有 384Kb/s）不足而开发的，亦称为3.75G，可在一个5MHz载波上的传输速率可达10-15 Mbit/s（如采用 MIMO 技术，则可达28 Mbit/s）、上传速度达 5.76Mb/s（使用3GPP Rel7技术，更达11.5 Mbit/s），令需要大量上传带宽的功能如双向视频直播或 VoIP 得以顺利实现，所以具体上都比3.5G好。 而各电讯业者亦表示在 2007 年尾至 2008 年间会开通该服务。
    NETWORK_TYPE_HSUPA: 'hsupa',
    // 高速封包存取（High Speed Packet Access, HSPA），是WCDMA第一个进化技术，HSPA可增加资料传输速率（1－3Mbps），可减少延迟。继 HSPA之后，还有HSDPA, HSUPA 以及 HSPA+的推出。
    NETWORK_TYPE_HSPA: 'hspa',

    NETWORK_TYPE_EHRPD: 'ehrpd',
    NETWORK_TYPE_HSPAP: 'hspap',
    // 4G
    // 3GPP长期演进技术（3GPP Long Term Evolution, LTE）为第三代合作伙伴计划（3GPP）标准，使用“正交频分复用”（OFDM）的射频接收技术，以及2×2和4×4 MIMO的分集天线技术规格。同时支援FDD（频分双工）和TDD（时分双工）。LTE是GSM超越3G与HSDPA阶段迈向4G的进阶版本。LTE也被俗称为3.9G。2010年12月6日国际电信联盟把LTE正式称为4G.
    NETWORK_TYPE_LTE: 'lte',
    // WiFi
    NETWORK_TYPE_WIFI: 'wifi',
    // unknown
    NETWORK_TYPE_UNKNOWN: 'unknown',
  };

  function translate(data, callback) {
    if (typeof data === 'string' && data.indexOf('Permission denied') != -1) {
      return callback && callback(data);
    }
    if (typeof data === 'string' && /^{.*?}$/.test(data)) {
      data = JSON.parse(data);
    }
    if (data && 'radio' in data) {
      if (data.type === 1) {
        data.radio = 'wifi';
      } else if (data.type >= 2) {
        data.radio = RADIO_TYPE_MAP[data.radio] || data.radio;
      } else {
        data.radio = 'unknown';
      }
    }
    callback && callback(data);
  }

  mqq.build('mqq.device.getNetworkInfo', {
    iOS(callback) {
      mqq.invokeClient('device', 'getNetworkInfo', {
        callback: mqq.callback(
          data => {
            translate(data, callback);
          },
          false,
          true
        ),
      });
    },
    android(callback) {
      mqq.invokeClient('qbizApi', 'getNetworkInfo', data => {
        translate(data, callback);
      });
    },
    supportInvoke: true,
    support: {
      iOS: '5.2',
      android: '5.2',
    },
  });
})();
/**
 * @function offline.isCached
 * @desc 查询本地是否有指定业务的离线包
 *
 * @param {Object} param
 * @param {Number} param.bid
 * @param {Function} callback
 * @param {Number} callback.localVersion 本地离线包版本号；-1: 无离线包
 *
 * @example
 * mqq.offline.isCached({bid: 123456}, function(localVersion){
 *     if(localVersion === -1){
 *         alert("no local offline data!");
 *     }
 * });
 *
 * @support iOS 4.6
 * @support android 4.6
 */
mqq.build('mqq.offline.isCached', {
  iOS(params, callback) {
    const callbackName = mqq.callback(callback);
    if (callbackName) {
      params.callback = callbackName;
      mqq.invokeClient('offline', 'isCached', params);
    }
  },
  android(params, callback) {
    mqq.invokeClient('qbizApi', 'isCached', params.bid, mqq.callback(callback));
  },
  supportInvoke: true,
  support: {
    iOS: '4.6',
    android: '4.6',
  },
}); /**
 * @function tenpay.pay
 * @desc 唤起财付通支付界面
 *
 * @param {Object} param
 * @param {String} param.prepayId 调用财付通后台接口生成的订单号（必选字段,20160901名称由tokenId变更而来,tokenId参数名称仍可使用）
 * @param {String} param.pubAcc 公众帐号uin，用于在支付成功后关注该公众帐号。
 * @support for param.pubAcc iOS 4.7
 * @support for param.pubAcc android 4.7

 * @param {String} param.pubAccHint 公众帐号关注提示语，用于显示在支付成功页面。
 * @support for param.pubAccHint iOS 4.7
 * @support for param.pubAccHint android 4.7

 * @param {String} param.appInfo 标记业务及渠道，用来统计各业务KPI完成度
 * @note for param.appInfo 注意：字段由三部分组成：
 * @note for param.appInfo appid#XXXXXXXXX|bargainor_id#XXXXXXXX|channel#XXXXX
 * @note for param.appInfo 注：由于url字段包含"="，所以不在appInfo字段使用"="，而改用"#"代替
 * @note for param.appInfo 第一部分：应用唯一id：appid
 * @note for param.appInfo - appid请咨询SNG增值渠道部分配唯一的appid；
 * @note for param.appInfo 第二部分：商户号：bargainor_id
 * @note for param.appInfo 第三部分：渠道：channel，目前分配值：
 * @note for param.appInfo - wallet：钱包首页商城
 * @note for param.appInfo - account：应用生活服务帐号
 * @note for param.appInfo - dongtai：动态
 * @note for param.appInfo - qun：群
 * @note for param.appInfo - huodong：热门活动
 * @note for param.appInfo - aio：聊天窗口
 * @note for param.appInfo - banner：手Qbanner
 * @note for param.appInfo - gdt：广点通
 * @note for param.appInfo - shareurl：分享链接
 * @note for param.appInfo - qrcode：扫码
 * @note for param.appInfo - wallet_account：QQ钱包官号
 * @note for param.appInfo - personalstore：个性装扮
 * @note for param.appInfo - qbjx：钱包精选
 * @note for param.appInfo - other：其它
 * @note for param.appInfo （其它发现无对应渠道的情况，请咨询SNG增值渠道部分配新渠道标识）

 * @param {Function} callback 支付成功/失败的回调
 * @param {Object} callback.result
 * @param {Number} callback.resultCode 错误码
 * @options for callback.resultCode -1: 未知错误
 * @options for callback.resultCode 0: 发货成功
 * @options for callback.resultCode 1: 下订单失败
 * @options for callback.resultCode 2: 支付失败
 * @options for callback.resultCode 3: 发货失败
 * @options for callback.resultCode 4: 网络错误
 * @options for callback.resultCode 5: 登录失败或无效
 * @options for callback.resultCode 6: 用户取消
 * @options for callback.resultCode 7: 用户关闭IAP支付
 *
 * @param {String} callback.result.retmsg 表示调用结果信息字符串。成功返回时为空串。出错时，返回出错信息
 * @param {Object} callback.result.data 当resultCode=0时，有返回data对象
 * @param {string} callback.result.data.transaction_id 财付通交易单号
 * @param {string} callback.result.data.pay_time 交易时间
 * @param {string} callback.result.data.total_fee 订单总金额（单位为分）
 * @param {string} callback.result.data.callback_url 商户提供的回调url地址（HTML5方式调用适用，其它情形为空）
 * @param {string} callback.result.data.sp_data 返回给商户的信息，商户前端可解析校验订单支付结果。
 *
 * @example
 * mqq.tenpay.pay({
 *     prepayId: "xxxx", //20160901名称由tokenId变更而来,老的tokenId参数名称仍可使用
 *     pubAcc: "xxxx",
 *     pubAccHint: "xxxx"
 * });
 *
 * @support iOS 4.6.1
 * @support android 4.6.1
 * @note 支付成功的回调在 Android 4.6.2 之前的实现有 Bug，4.6.0之前从aio打开的webview会没有回调，4.6.1在生活优惠的webview会没有回调。需要页面兼容一下，给个提示框让用户点击，从后台查支付状态。最新版本已经修复。
 * @change v4.7.0: 增加 pubAcc 和 pubAccHint 参数
 */
(function() {
  const wrapCallback = function(callback) {
    return function(resultCode, data, raw) {
      // iOS端手Q5.3.1 开始，就直接返回json对象格式参数，无需在做解析
      if (raw) {
        try {
          callback && callback(JSON.parse(raw));
          return;
        } catch (e) {}
      }

      // 返回的 resultCode 有可能是字符串数字
      resultCode = Number(resultCode);

      const result = {
        resultCode,
        retmsg: '',
        data: {},
      };
      if (resultCode === 0) {
        // 保存原始attach信息
        const rawData = data;

        data = mqq.mapQuery(data);
        // 此处与android返回一致
        data.sp_data = rawData;

        if (data.attach && data.attach.indexOf('{') === 0) {
          data.attach = JSON.parse(data.attach);
        }
        if (data.time_end) {
          data.pay_time = data.time_end;
        }
        result.data = data;
      } else if (resultCode === 1 || resultCode === -1) {
        result.retmsg = '用户主动放弃支付';
        result.resultCode = -1;
      } else {
        result.retmsg = data;
      }

      callback && callback(result);
    };
  };

  mqq.build('mqq.tenpay.pay', {
    iOS(params, callback) {
      params.order_no = params.tokenId || params.tokenID || params.prepayId;
      params.app_info = params.app_info || params.appInfo;
      // 如果调用时有传入使用回调函数封装则封装回调，否则直接透传
      // params['wrapResult'] = params['wrapResult'] || false;

      if (mqq.compare('4.6.2') >= 0) {
        mqq.invokeSchema('mqqapi', 'wallet', 'pay', params, wrapCallback(callback));
      } else {
        mqq.invokeSchema('mqqapiwallet', 'wallet', 'pay', params, wrapCallback(callback));
      }
    },
    android(params, callback) {
      // 不是token_id。20170925修复
      params.tokenId = params.tokenId || params.tokenID || params.prepayId;
      params.app_info = params.app_info || params.appInfo;
      // 如果调用时有传入使用回调函数封装则封装回调，否则直接透传
      // params['wrapResult'] = params['wrapResult'] || false;

      if (mqq.compare('4.6.1') >= 0) {
        // 4.6.1 有新的接口
        mqq.invokeClient('pay', 'pay', JSON.stringify(params), callback);
      } else {
        mqq.invokeSchema('mqqapi', 'tenpay', 'pay', params, wrapCallback(callback));
      }
    },
    supportInvoke: true,
    support: {
      iOS: '4.6.1',
      android: '4.6.1',
    },
  });
})();
/**
 * @namespace ui
 * @desc 界面相关接口
 */
/**
 * @function ui.closeWebViews
 * @desc 关闭所有相邻的 WebView（包括直接相邻的和间接相邻的）
 *
 * @param {Object} param
 *
 * @param {Number} param.mode 关闭模式，有如下几种模式：
 * @options for param.mode 0: 默认模式，关闭所有相邻 webview
 * @options for param.mode 1: 关闭在当前webview之上的所有相邻webview
 * @options for param.mode 2: 关闭在当前webview之下的所有相邻webview
 *
 * @param {Boolean} param.exclude 是否不关闭当前webview
 * @default for param.exclude false - 关闭当前webview
 * @note 当前webview指调用本接口的webview，不一定是当前可见的webview
 *
 * @support iOS 5.2
 * @support android 5.2
 */

mqq.build('mqq.ui.closeWebViews', {
  iOS(params) {
    mqq.invokeClient('ui', 'closeWebViews', params || {});
  },
  android(params) {
    mqq.invokeClient('ui', 'closeWebViews', params || {});
  },
  supportInvoke: true,
  support: {
    iOS: '5.2',
    android: '5.2',
  },
});
/**
 * @function ui.openUrl
 * @desc 打开指定url
 *
 * @param {Object} param
 *
 * @param {String} param.url
 * @param {Number} param.target
 * @options for param.target 0: 在当前webview打开
 * @options for param.target 1: 在新webview打开
 * @options for param.target 2: 在外部浏览器上打开（iOS为Safari,Android为系统默认浏览器）
 * @default for param.target 0: 在当前webview打开
 *
 * @param {Number} param.style WebView的样式（只对target=1有效），可选值如下：
 * @options for param.style 0: 顶部标题栏模式（无底部工具栏）
 * @options for param.style 1: 顶部标题栏无分享入口（无底部工具栏）
 * @options for param.style 2: 底部工具栏模式（顶部标题依然会存在）
 * @options for param.style 3: 底部工具栏模式且顶部无分享入口（顶部标题依然会存在）
 * @default for param.style 0: 顶部标题栏模式（无底部工具栏）
 *
 * @param {Number} param.animation  ( v4.7 ) webview展示动画，（该参数仅对Android有效）可选值如下：
 * @options for param.animation 0: 从右往左
 * @options for param.animation 1: 直接打开
 * @options for param.animation 2: 从下往上
 * @default for param.animation 0: 从右往左
 * @support for param.animation Android 4.7
 *
 * @example
 * //用一个带底部导航栏、无分享按钮的WebView来打开链接
 * mqq.ui.openUrl({
 *     url: "http://news.qq.com",
 *     target: 1,
 *     style: 3
 * });
 *
 * @support iOS 4.5
 * @support android 4.6
 *
 * @changelist v4.7: android 4.7 已经把从 AIO 打开的 WebView 改为非单例，也就是用 openUrl({target: 1}) 能真正打开新的 WebView 了
 */
(function() {
  const used = {};
  const interval = 500; // 暂定500ms

  // 调用频率限制
  function canUse(url) {
    const ts = used[url];
    const now = +new Date();

    if (ts && now - ts < interval) {
      return false;
    }

    used[url] = now;
    return true;
  }

  // 支持适配当前页面使用的协议, 如http、https
  function adaptProtocol(url) {
    if (url && url.indexOf('//') === 0) {
      url = window.location.protocol + url;
    }
    return url;
  }

  mqq.build('mqq.ui.openUrl', {
    iOS(params) {
      if (!canUse(params.url)) {
        return;
      }

      if (!params) {
        params = {};
      }
      const url = adaptProtocol(params.url);

      if (params.target === 2) {
        mqq.invokeClient('nav', 'openLinkInSafari', {
          url,
        });
      } else if (params.target === 1) {
        params.styleCode =
          {
            1: 4,
            2: 2,
            3: 5,
          }[params.style] || 1;
        mqq.invokeClient('nav', 'openLinkInNewWebView', {
          url,
          options: params,
        });
      } else {
        window.open(url, '_self');
      }
    },
    android(params) {
      if (!canUse(params.url)) {
        return;
      }

      if (!params) {
        params = {};
      }
      const url = adaptProtocol(params.url);

      if (params.target === 2) {
        if (mqq.compare('4.6') >= 0) {
          mqq.invokeClient('publicAccount', 'openInExternalBrowser', url);
        } else if (mqq.compare('4.5') >= 0) {
          mqq.invokeClient('openUrlApi', 'openUrl', url);
        }
      } else if (params.target === 1) {
        if (!params.style) {
          params.style = 0;
        }

        if (mqq.compare('4.7') >= 0) {
          mqq.invokeClient('ui', 'openUrl', {
            url,
            options: params,
          });
        } else if (mqq.compare('4.6') >= 0) {
          mqq.invokeClient('qbizApi', 'openLinkInNewWebView', url, params.style);
        } else if (mqq.compare('4.5') >= 0) {
          mqq.invokeClient('publicAccount', 'openUrl', url);
        } else {
          window.open(url, '_self');
        }
      } else {
        window.open(url, '_self');
      }
    },
    browser(params) {
      // 兼容普通浏览器的调用
      if (!params) {
        params = {};
      }
      const url = adaptProtocol(params.url);

      if (params.target === 2) {
        window.open(url, '_blank');
      } else {
        window.open(url, '_self');
      }
    },
    supportInvoke: true,
    support: {
      iOS: '4.5',
      android: '4.6',
      browser: '0',
    },
  });
})();
/**
 * @function ui.popBack
 * @desc 关闭当前webview
 *
 * @example
 * mqq.ui.popBack();
 *
 * @support iOS 4.5
 * @support android 4.6
 */

mqq.build('mqq.ui.popBack', {
  iOS() {
    mqq.invokeClient('nav', 'popBack');
  },
  android() {
    mqq.invokeClient('publicAccount', 'close');
  },
  supportInvoke: true,
  support: {
    iOS: '4.5',
    android: '4.6',
  },
});
/**
 * @function ui.refreshTitle
 * @desc 刷新客户端显示的网页标题。在iOS中，网页标题动态改变后，显示WebView的导航栏标题不会改变，请调用refreshTitle来手动刷新。Android不需要。
 *
 * @example
 * document.title="新标题";
 * mqq.ui.refreshTitle();
 *
 * @support iOS 4.6
 * @support android not support
 */
mqq.build('mqq.ui.refreshTitle', {
  iOS() {
    mqq.invokeClient('nav', 'refreshTitle');
  },
  supportInvoke: true,
  support: {
    iOS: '4.6',
  },
});
/**
 * @function ui.setOnShareHandler
 * @desc 设置web页面分享的监听事件。用户点击右上角的弹出菜单后，点击了分享时会通知页面，此时需要调用 shareMessage 主动发起分享（系统默认的分享行为不再执行）
 *
 * @param {Function} callback
 * @param {Number} callback.type 用户点击的分享类型
 * @options for callback.type 0：QQ好友
 * @options for callback.type 1：QQ空间
 * @options for callback.type 2：微信好友
 * @options for callback.type 3：微信朋友圈
 *
 * @support iOS 4.7.2
 * @support android 4.7.2
 * @note android 的实现跟 iOS 不太一致，android 上如果设置了点击分享的回调，10s内没有调用 shareMessage 的话，将会继续执行用户选择的分享流程，5.0修复这个问题
 */
mqq.build('mqq.ui.setOnShareHandler', {
  iOS(callback) {
    mqq.invokeClient('nav', 'addWebShareListener', {
      callback: mqq.callback(callback),
    });
  },
  android(callback) {
    mqq.invokeClient('ui', 'setOnShareHandler', {
      callback: mqq.callback(callback),
    });
  },
  supportInvoke: true,
  support: {
    iOS: '4.7.2',
    android: '4.7.2',
  },
});
/**
 * @function ui.setTitleButtons
 * @desc 配置webview顶部按钮的标题、点击回调等
 *
 * @param {Object} param 参数不能不传，否则会报js错误
 *
 * @param {Object} param.left 左按钮
 * @param {String} param.left.title 文案
 * @support for param.left.title iOS 4.7.2
 * @support for param.left.title android 5.3
 *
 * @param {String} param.left.callback 回调
 * @support for param.left.callback iOS 4.7.2
 * @support for param.left.callback android 4.7
 *
 * @param {Object} param.right 右按钮
 * @param {String}  param.right.title 文案
 * @support for param.right.title iOS 4.6
 * @support for param.right.title android 4.6
 *
 * @param {Boolean} param.right.hidden 是否隐藏右上角按钮
 * @support for param.right.hidden iOS 4.7
 * @support for param.right.hidden android 4.7
 *
 * @param {Number} param.right.iconID 图标的本地资源ID（只支持内置的资源）
 * @options for param.right.iconID 1: 编辑图标
 * @options for param.right.iconID 2: 删除图标
 * @options for param.right.iconID 3: 浏览器默认图标
 * @options for param.right.iconID 4: 分享图标
 * @options for param.right.iconID 5: 上传图标（有动画效果）
 * @options for param.right.iconID 7: 感叹号图标*
 * @support for param.right.iconID iOS 4.7
 * @support for param.right.iconID android 4.7
 *
 * @param {String} param.right.callback 回调
 *
 *
 * @example
 * mqq.ui.setTitleButtons({
 *    left : {
 *        title : "返回",
 *        callback : function () {
 *            alert("点击左按钮")
 *        }
 *    },
 *    right : {
 *        title : "我的...",
 *        callback : function () {
 *            alert("点击右按钮")
 *        }
 *    }
 * })
 *
 * @support iOS 4.6
 * @support android 4.6
 */
mqq.build('mqq.ui.setTitleButtons', {
  iOS(params) {
    const { left } = params;
    const { right } = params;

    if (left) {
      left.callback = mqq.callback(left.callback);
    }
    if (right) {
      right.callback = mqq.callback(right.callback);
    }

    if (mqq.compare('5.3') >= 0) {
      mqq.invokeClient('ui', 'setTitleButtons', params);

      // 5.3之前需要使用`setLeftBtnTitle`、`setOnCloseHandler`跟`setActionButton`整合
    } else {
      if (left) {
        if (left.title) {
          mqq.invokeClient('ui', 'setLeftBtnTitle', { title: left.title });
        }
        if (left.callback) {
          mqq.invokeClient('ui', 'setOnCloseHandler', left);
        }
      }
      if (right) {
        /* if (typeof hasRight !== 'object') {
                    hasRight = {
                        title: hasRight
                    };
                } */
        mqq.invokeClient('nav', 'setActionButton', right);
      }
    }
  },
  android(params) {
    const { left } = params;
    const { right } = params;

    if (left) {
      left.callback = mqq.callback(left.callback);
    }
    if (right) {
      right.callback = mqq.callback(right.callback);
    }

    if (mqq.compare('5.3') >= 0) {
      mqq.invokeClient('ui', 'setTitleButtons', params);

      // 5.3之前需要使用`setOnCloseHandler`跟`setActionButton`整合
    } else {
      if (left) {
        if (left.callback) {
          mqq.invokeClient('ui', 'setOnCloseHandler', left);
        }
        /* left.type = "left";
                left.wording = left.title;

                mqq.invokeClient('ui', 'setTitleButton', left); */
      }
      if (right) {
        if (right.hidden) {
          right.title = '';
        }

        if (mqq.compare('4.7') >= 0) {
          mqq.invokeClient('ui', 'setActionButton', right);
        } else {
          mqq.invokeClient('publicAccount', 'setRightButton', right.title, '', right.callback);
        }
      }
    }
  },
  supportInvoke: true,
  support: {
    iOS: '5.0',
    android: '4.6',
  },
});
/**
 * @function ui.shareMessage
 * @desc 调用客户端的分享接口，分享内容给好友/群，调用后会弹出联系人选择列表
 *
 * @param {Object} param
 *
 * @param {String} param.title 必填，消息标题，最长45字节
 * @param {String} param.desc 必填，消息摘要，最长60字节。
 * @param {Number} param.share_type 分享的目标类型，0：QQ好友；1：QQ空间；2：微信好友；3：微信朋友圈。默认为 0
 * @param {String} param.share_url 必填，点击消息后的跳转url，最长120字节。原 targetUrl 参数，可以继续使用 targetUrl
 * @param {String} param.image_url 必填，消息左侧缩略图url。图片推荐使用正方形，宽高不够时等比例撑满，不会变形。原 imageUrl 参数，可以继续使用 imageUrl。注意：图片最小需要200 * 200，否则分享到Qzone时会被Qzone过滤掉。
 * @param {Boolean} param.back 发送消息之后是否返回到web页面，默认false，直接到AIO，注：该参数只对share_type=0时起作用
 * @support for param.back iOS 5.0
 * @support for param.back android 4.7.2
 *
 * @param {String} param.shareElement 分享的类型，目前支持图文和音乐分享。news：图文分享类型，audio：音乐分享类型，video：视频分享类型。默认为news
 * @support for param.shareElement iOS 5.0
 * @support for param.shareElement android 5.0
 *
 * @param {String} param.flash_url 如果分享类型是音乐或者视频类型，则填写流媒体url
 * @support for param.flash_url iOS 5.0
 * @support for param.flash_url android 5.0
 *
 * @param {String} param.puin 公众帐号uin，用于自定义结构化消息尾巴，只在公众账号分享的时候填写，若不是请不要填，当puin没有索引到本地记录，则显示sourceName字段的文本，若没有sourceName字段，则直接显示puin数字
 * @support for param.puin iOS 5.0
 * @support for param.puin android 5.0
 *
 * @param {String} param.appid 来源 appid，在QQ互联申请的的 appid，如果有，可以填上
 * @support for param.appid iOS 5.0
 * @support for param.appid android 5.0
 *
 * @param {String} param.sourceName 消息来源名称，默认为空，优先读取 appid 对应的名字，如果没有则读取 puin 对应的公众账号名称
 * @param {String} param.toUin 分享给指定的好友或群，如果存在这个参数，则不拉起好友选择界面 (针对分享给好友)
 * @support for param.toUin iOS 5.0
 * @support for param.toUin android 5.0
 *
 * @param {Number} param.uinType 分享给指定的好友或群的uin类型: 0：好友；1：群 (针对分享给好友)
 * @support for param.uinType iOS 5.0
 * @support for param.uinType android 5.0
 *
 *
 * @param {Function} callback
 * @note for callback 分享到微信和朋友圈在手Q5.4之后开始支持回调
 * @param {Object} callback.result
 * @param {Number} callback.result.retCode 返回码
 * @options for callback.result.retCode 0：用户点击发送，完成整个分享流程
 * @options for callback.result.retCode 1：用户点击取消，中断分享流程
 * @options for callback.result.retCode -2：iOS端分享到微信或朋友圈时，手动取消分享将返回-2
 *
 * @important android6.2.1 bug 分享到空间回调值无效, 必为1, 修复方案待定(咨询hongxingcui)
 *
 * @support iOS 4.7.2
 * @support android 4.7.2
 *
 * @care 可自定义appid/source伪造任意来源的分享（QQ消息小尾巴）
 */
mqq.build('mqq.ui.shareMessage', {
  iOS(params, callback) {
    if (!('needPopBack' in params) && 'back' in params) {
      params.needPopBack = params.back;
    }
    if (params.share_url) {
      params.share_url = mqq.removeQuery(params.share_url, ['sid', '3g_sid']);
    }
    if (params.desc) {
      params.desc = params.desc.length > 50 ? `${params.desc.substring(0, 50)}...` : params.desc;
    }
    // 终端接受字符串类型UIN，这里统一帮忙处理
    if (params.toUin) {
      params.toUin += '';
    }
    // 兼容5.4版本
    if (params.sourceName) {
      params.srcName = params.sourceName;
    }
    params.callback = mqq.callback(callback, true /* deleteOnExec */, true);
    mqq.invokeClient('nav', 'shareURLWebRichData', params);
  },
  android(params, callback) {
    if (params.share_url) {
      params.share_url = mqq.removeQuery(params.share_url, ['sid', '3g_sid']);
    }
    params.callback = mqq.callback(result => {
      callback &&
        callback({
          retCode: result ? 0 : 1,
        });
    }, true /* deleteOnExec */);
    if (params.desc) {
      params.desc = params.desc.length > 50 ? `${params.desc.substring(0, 50)}...` : params.desc;
    }
    if (params.srcName) {
      params.sourceName = params.srcName;
    }

    if (
      params.share_type &&
      (params.share_type === 2 || params.share_type === 3) &&
      mqq.compare('5.2') < 0 &&
      mqq.support('mqq.app.isAppInstalled')
    ) {
      // 先检查有没有安装微信, ios不用, ios会自己弹出一个 toast 提示
      // 5.2 android 也会自己检查
      const unsupportTips = '您尚未安装微信，不可使用此功能';
      mqq.app.isAppInstalled('com.tencent.mm', result => {
        if (result) {
          mqq.invokeClient('QQApi', 'shareMsg', params);
        } else if (mqq.support('mqq.ui.showTips')) {
          mqq.ui.showTips({
            text: unsupportTips,
          });
        } else {
          alert(unsupportTips);
        }
      });
    } else {
      mqq.invokeClient('QQApi', 'shareMsg', params);
    }
  },
  supportInvoke: true,
  support: {
    iOS: '4.7.2',
    android: '4.7.2',
  },
});
/**
 * @function ui.showDialog
 * @desc 弹出一个确认框
 *
 * @param {Object} param
 *
 * @param {String} param.title 确认框的标题
 * @param {String} param.text 确认框的提示内容
 * @param {Boolean} param.needOkBtn 是否显示确认按钮
 * @param {Boolean} param.needCancelBtn 是否显示取消按钮
 * @param {String} param.okBtnText 确认按钮的文本(默认为"确定")
 * @support for param.okBtnText iOS 5.0
 * @support for param.okBtnText android 5.0
 *
 * @param {String} param.cancelBtnText 取消按钮的文本(默认为"取消")
 * @support for param.cancelBtnText iOS 5.0
 * @support for param.cancelBtnText android 5.0
 *
 * @param {Function} callback
 * @param {Object} callback.result 点击按钮的返回结果
 * @param {Number} callback.result.button 指示用户点击的按钮, 0: 点击了确认按钮; 1: 点击了取消按钮
 *
 * @support iOS 4.6
 * @support android 4.6
 * @note needOkBtn 和 needCancelBtn 至少要有一个为 true
 *
 * @care 可弹出一个自定义内容的对话框，存在钓鱼推广风险
 */
mqq.build('mqq.ui.showDialog', {
  iOS(params, callback) {
    if (params) {
      params.callback = mqq.callback(callback, true /* deleteOnExec */);
      params.title += '';
      params.text += '';
      if (!('needOkBtn' in params)) {
        params.needOkBtn = true;
      }
      if (!('needCancelBtn' in params)) {
        params.needCancelBtn = true;
      }
      // 字段兼容
      params.okBtnStr = params.okBtnText;
      params.cancelBtnStr = params.cancelBtnText;

      mqq.invokeClient('nav', 'showDialog', params);
    }
  },
  android(params, callback) {
    if (mqq.compare('4.8.0') >= 0) {
      params.callback = mqq.callback(callback, true);
      mqq.invokeClient('ui', 'showDialog', params);
    } else {
      let okCbName = '';
      let cancelCbName = '';

      if (callback) {
        okCbName = mqq.callback(() => {
          callback({
            button: 0,
          });
        }, true);
        cancelCbName = mqq.callback(() => {
          callback({
            button: 1,
          });
        }, true);

        okCbName += '()';
        cancelCbName += '()';
      }
      params.title += '';
      params.text += '';
      if (!('needOkBtn' in params)) {
        params.needOkBtn = true;
      }
      if (!('needCancelBtn' in params)) {
        params.needCancelBtn = true;
      }
      mqq.invokeClient(
        'publicAccount',
        'showDialog',
        params.title,
        params.text,
        params.needOkBtn,
        params.needCancelBtn,
        okCbName,
        cancelCbName
      );
    }
  },
  supportInvoke: true,
  support: {
    iOS: '4.6',
    android: '4.6',
  },
});
/**
 * @function ui.showShareMenu
 * @desc 唤起分享面板，就是默认情况下点击 WebView 右上角的按钮时弹出的面板
 *
 * @support iOS 5.2
 * @support android 5.2
 */
mqq.build('mqq.ui.showShareMenu', {
  iOS() {
    mqq.invokeClient('ui', 'showShareMenu');
  },
  android() {
    mqq.invokeClient('ui', 'showShareMenu');
  },
  supportInvoke: true,
  support: {
    iOS: '5.2',
    android: '5.2',
  },
});
